import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import API from 'api';
import Box from '@material-ui/core/Box';
import Ad from 'models/business/Ad';
import GeneralAdCard from './GeneralAdCard';
import NewAdCard from './NewAdCard';

export default function AdDashboard({ ads, amounts }) {
  // const [ads, setAds] = useState([]);

  // const getAdList = async () => {
  //   const result = await API.ad.postAdList();
  //   if (result.errorMsg === '0000') {
  //     setAds(result.resultData);
  //   } else {
  //     alert(result.error.errorMsg);
  //   }
  // };

  // useEffect(() => {
  //   getAdList();
  // }, []);
  const changeAdStatus = async (id, adStatus) => {
    return;
    // eslint-disable-next-line no-unreachable
    const result = await API.ad.postUpdateAd(
      id,
      null,
      adStatus,
      null,
      null,
      null,
    );

    if (result.errorMsg === '0000') {
      if (adStatus === 'Pending') alert('上搞需求發送成功');
      else if (adStatus === 'Stopped') alert('暫停成功');
      else if (adStatus === 'Inline') alert('更新上搞需求成功');
      // getAdList();
    } else {
      alert(result.error.errorMsg);
    }
  };

  const renderAdCards = useMemo(() => (
    ads.map((ad) => (
      <Box
        mb={2}
        key={ad.id}
      >
        <GeneralAdCard
          ad={new Ad(ad)}
          amounts={amounts}
          sendMaterialOnClick={() => changeAdStatus(ad.id, 'Pending')}
          updateMaterialOnClick={() => changeAdStatus(ad.id, 'Inline')}
        />
      </Box>
    ))
  ), [ads]);

  return (
    <Box
      display="flex"
      flexDirection="column"
    >
      <Box
        mb={2}
      >
        <NewAdCard />
      </Box>
      {renderAdCards}
    </Box>
  );
}

AdDashboard.propTypes = {
  ads: PropTypes.arrayOf(PropTypes.instanceOf(Ad)),
  // eslint-disable-next-line react/forbid-prop-types
  amounts: PropTypes.object,
};

AdDashboard.defaultProps = {
  ads: [],
  amounts: {},
};
